module.exports = __webpack_public_path__ + "img/12521.79e80604.jpg";